import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { colors } from 'bench-style-constants';
import { Icon } from 'primitive-components';
type Props = {
  children: ReactNode;
  icon: string;
};
const Badge = styled.span.attrs(({ children, icon }: Props) => ({
  children: icon ? <Icon icon={icon} /> : children,
}))`
  background-color: ${colors.copper};
  border-radius: 9px;
  color: ${colors.white};
  font-size: 10px;
  padding: 0 5px 1px;

  ${({ icon }: Props) =>
    icon &&
    css`
      height: 16px;
      padding: 2px;
      width: 16px;
    `} svg {
    fill: ${colors.white};
    height: 10px;
    width: 10px;
  }
`;
export default Badge;
